import { useEffect, useState } from 'react';
import { useUser } from '../context/UserContext';
import { getOutletServiceSettings } from '../utils/franchisePriceServicesApi';

function fromUserProfile(user) {
  return user?.passport_checkin_enabled === true || user?.passportCheckinEnabled === true;
}

/** Franchise flag from profile + outlet-settings API (JWT franchise scope). */
export function usePassportCheckinEnabled() {
  const { user } = useUser() || {};
  const [outletFlag, setOutletFlag] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getOutletServiceSettings()
      .then((data) => {
        if (!cancelled) setOutletFlag(Boolean(data?.passport_checkin_enabled));
      })
      .catch(() => {
        if (!cancelled) setOutletFlag(null);
      });
    return () => {
      cancelled = true;
    };
  }, [user?.id, user?.passport_checkin_enabled, user?.passportCheckinEnabled]);

  if (outletFlag === true || fromUserProfile(user)) return true;
  if (outletFlag === false && !fromUserProfile(user)) return false;
  return fromUserProfile(user);
}
